import { useState } from 'react';
import { Popover } from 'antd';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { Button, Icon } from '@/modules/ui';

import type { Group } from '../../types';
import { GroupDetail } from '../GroupDetail';
import * as felaRules from './GroupDetailButton.rules';

export interface GroupDetailButtonProps {
    id: Group['id'];
    name?: Group['name'];
}

export const GroupDetailButton = ({ id, name }: GroupDetailButtonProps) => {
    const [visible, setVisible] = useState(false);

    const { css } = useFela({ popoverOpen: visible });

    return (
        <Popover
            content={<GroupDetail id={id} />}
            trigger='click'
            open={visible}
            onOpenChange={v => setVisible(v)}
            classNames={{ root: css(felaRules.popover) }}
            align={{ points: ['tl', 'bl'], offset: [0, 4] }}
            arrow={false}
        >
            <Button
                icon={<Icon type='caret' className={css(felaRules.caret)} />}
                type='text'
                color='foregroundsPrimary'
                size='large'
                customStyle={felaRules.button}
            >
                {name ? <span className={css(felaRules.name)}>{name}</span> : <FormattedMessage id='group.detail' />}
            </Button>
        </Popover>
    );
};
